/**
 * DataIngestion API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpContext 
        }       from '@angular/common/http';
import { Observable }                                        from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { DslErrorResponseDto } from '../model/dsl-error-response';
// @ts-ignore
import { DslIndicatorResponseDto } from '../model/dsl-indicator-response';
// @ts-ignore
import { RegistryTypeDto } from '../model/registry-type';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';
import {
    DslServiceInterface,
    GetDslIndicatorsByDocumentRequestParams
} from './dsl.serviceInterface';



@Injectable({
  providedIn: 'root'
})
export class DslService extends BaseService implements DslServiceInterface {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Retrieves indicators from the DSL service based on document type and value.
     * @endpoint get /v1/dsl/indicators/{registryType}/{documentValue}
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public getDslIndicatorsByDocument(requestParameters: GetDslIndicatorsByDocumentRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<Array<DslIndicatorResponseDto>>;
    public getDslIndicatorsByDocument(requestParameters: GetDslIndicatorsByDocumentRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<Array<DslIndicatorResponseDto>>>;
    public getDslIndicatorsByDocument(requestParameters: GetDslIndicatorsByDocumentRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<Array<DslIndicatorResponseDto>>>;
    public getDslIndicatorsByDocument(requestParameters: GetDslIndicatorsByDocumentRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        const registryType = requestParameters?.registryType;
        if (registryType === null || registryType === undefined) {
            throw new Error('Required parameter registryType was null or undefined when calling getDslIndicatorsByDocument.');
        }
        const documentValue = requestParameters?.documentValue;
        if (documentValue === null || documentValue === undefined) {
            throw new Error('Required parameter documentValue was null or undefined when calling getDslIndicatorsByDocument.');
        }
        const mock = requestParameters?.mock;
        const mockStatusCode = requestParameters?.mockStatusCode;
        const mockExternalStatusCode = requestParameters?.mockExternalStatusCode;

        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'mock',
            <any>mock,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'mockStatusCode',
            <any>mockStatusCode,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'mockExternalStatusCode',
            <any>mockExternalStatusCode,
            QueryParamStyle.Form,
            true,
        );


        let localVarHeaders = this.defaultHeaders;

        // authentication (OidcBearer) required
        localVarHeaders = this.configuration.addCredentialToHeaders('OidcBearer', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/v1/dsl/indicators/${this.configuration.encodeParam({name: "registryType", value: registryType, in: "path", style: "simple", explode: false, dataType: "RegistryTypeDto", dataFormat: undefined})}/${this.configuration.encodeParam({name: "documentValue", value: documentValue, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Array<DslIndicatorResponseDto>>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters.toHttpParams(),
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
